module.exports = __webpack_public_path__ + "static/arquitecta-heavy-e4b0550df7141c0cca7906ea8c2d6a89.woff";